import React from 'react';

export default () => {
    return (
      <div className="pressword-info-container">
        <div className="pressword-info-inner">
          <h2>PressWord</h2>
          <p>Customise WordPress admin events with API hooks.</p>
          
          <h3>Changelog</h3>
          <h3>Resources</h3>
          <ul>
            <li><a href="http://sisumedia.com" target="_blank"><i aria-hidden="true" className="dashicons dashicons-external"></i> Sisu</a></li>
            <li><a href="https://www.github.com/unclesisu/pressword" target="_blank"><i aria-hidden="true" className="dashicons dashicons-external"></i> Documentation</a></li>
            <li><a href="https://www.github.com/unclesisu/pressword/issues" target="_blank"><i aria-hidden="true" className="dashicons dashicons-external"></i> Support</a></li>
          </ul>
        </div>
        <div className="pressword-info-footer">
          <p>Thank you for creating with <a href="https://www.github.com/unclesisu/pressword">PressWord</a>.</p>
        </div>
      </div>
    )
}
